/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import EntityOrUrlField from '../EntityOrUrlField';
import PageField from '../PageField';

const PageOrUrlField = React.forwardRef(({ entityName = 'page', ...props }, ref) => {
  return (
    <EntityOrUrlField {...props} ref={ref} entityName={entityName}>
      {({ innerRef, ...entityFieldProps }) => (
        <PageField ref={innerRef} {...entityFieldProps} extra={null} wrapperCol={{ span: 24 }} />
      )}
    </EntityOrUrlField>
  );
});

export default PageOrUrlField;
